module.exports = __webpack_public_path__ + "images/psp/PSPLinks/BoatStorage.svg";